import { List, ListSubheader } from '@mui/material';
import { useSidebarExpanded } from '../sidebar.context';

const SidebarGroup = ({ title = () => null, children, onClose }) => {
  const expanded = useSidebarExpanded();

  return (
    <List
      component="div"
      disablePadding
      subheader={
        expanded ? (
          <ListSubheader
            sx={{ lineHeight: 2, backgroundColor: 'transparent' }}
            data-testid="SidebarGroup.ListSubheader"
          >
            {title()}
          </ListSubheader>
        ) : undefined
      }
      dense
      data-testid="SidebarGroup.List"
      sx={{ mb: expanded ? 4 : 2 }}
    >
      {children.map((node, i) => (
        <node.component {...node} key={`${node.title}${i}`} onClose={onClose} />
      ))}
    </List>
  );
};

export default SidebarGroup;
